class JWPlayerVideo {
    constructor(videoWrapper) {
        Object.defineProperty(this, "wrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "jwplayerElement", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "videoUrl", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.wrapper = videoWrapper;
        this.jwplayerElement = this.wrapper.querySelector('.jwplayer');
        this.videoUrl = this.jwplayerElement?.dataset.video ?? '';
    }
    init() {
        if (!this.jwplayerElement)
            return;
        jwplayer(this.jwplayerElement).setup({
            playlist: this.videoUrl,
            mute: false,
            repeat: false,
            autostart: false,
        });
    }
}
export default function jwplayerSetup() {
    const video = document.querySelectorAll('.block-jwplayer');
    for (const element of video) {
        const videoElement = new JWPlayerVideo(element);
        videoElement.init();
    }
}
